export enum MixpanelEvents {
  PAGE_VIEW = "Page View",
  LEAD_PAGE_NAVIGATION = "Lead Page Navigation",
  LEADS_TABLE_FILTERS_APPLIED = "Leads Table Filters Applied",

  EOI_BUTTON_CLICK = "EOI Button Click",
  RESERVED_BUTTON_CLICK = "Reserved Button Click",
  WHEEL_DETAILS_CLICK = "Wheel Details Button Click",
  UNIT_BLOCKED_BUTTON_CLICK = "Unit Blocked Button Click",

  TASKS = "Overview-Tasks Card Click",
  MEETING = "Overview-Meeting Card Click",
  FRESH_LEADS = "Overview-Fresh-Leads Card Click",
  PRESENTATION = "Overview-Presentation Card Click",
  UNANSWERED_LEADS = "Overview-Unanswered Card Click",

  TASK_MARKED_AS_DONE = "Task Marked As Done",
  USER_ACTION = "User Action",
  
  EREALTY_PRESENTATION_FILTERS_SUBMIT = "eRealty Presentation Filters Submit",
  EXPO_QR_REGENERATED = "expo_qr_regenerated",
  EXPO_QR_SEND_TO_CLIENT = "expo_qr_send_to_client",
}

export enum MixpanelSystemActionTypes {
  VIEW_ALL_TASKS = "View All Tasks",
  VIEW_ALL_LEADS = "View All Leads",
}
